<div class="template-panel">
  <p class="template-intro">
    When you are ready, send the project an e-mail using <strong>the suggested template</strong> below to schedule the next call.
  </p>

  <button type="button" class="template-toggle" (click)="opened = !opened">
    Next meeting e-mail template
    <i class="fa" [ngClass]="opened ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </button>

  <div *ngIf="opened" class="template-body">
    <p><strong>Subject: HSBooster.eu – Next meeting with Expert</strong></p>
    <p>Dear [Project Applicant Name],</p>
    <p>Following our previous meeting, I am writing to schedule the next call with you.</p>
    <p>Here are some options that you can choose from:</p>
    <ul>
      <li>Insert option 1</li>
      <li>Insert option 2</li>
      <li>Insert option 3</li>
    </ul>
    <p>Looking forward to your feedback.</p>
    <p>Best regards,<br>Expert signature</p>
  </div>
</div>
